// src/components/PresupuestoPDFLink.js
import React, { useState } from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PresupuestoPDF_V2 from '../PresupuestoPDF_V2';
import { FaSpinner, FaFilePdf } from 'react-icons/fa';

const PresupuestoPDFLink = ({ presupuesto, type, icon }) => {
    // Estado para saber si debemos "montar" el PDF (prepararlo)
    const [isReady, setIsReady] = useState(false);

    // Activamos la preparación al pasar el mouse (para que esté listo al hacer click)
    const handlePrepare = () => {
        if (!isReady) setIsReady(true);
    };

    const getFileName = () => {
        const num = presupuesto?.pedidoVinculado || presupuesto?.numero || 'Doc';
        const cliente = presupuesto?.cliente?.name || 'Cliente';
        
        // Limpiamos caracteres raros del nombre del archivo
        const safeCliente = cliente.replace(/[^a-zA-Z0-9 ]/g, "");

        if (type === 'orden') return `Orden_${num}_${safeCliente}.pdf`;
        if (type === 'interno') return `Calculo_${num}_${safeCliente}.pdf`;
        if (type === 'taller') return `Taller_${num}_${safeCliente}.pdf`;
        
        return `Presupuesto_${num}_${safeCliente}.pdf`;
    };

    // Si no hay datos, mostramos un icono gris deshabilitado
    if (!presupuesto) {
        return <span className="text-gray-300 cursor-not-allowed"><FaFilePdf /></span>;
    }

    return (
        <div 
            onMouseEnter={handlePrepare} 
            onClick={handlePrepare} // Por si es táctil
            className="inline-block"
            title="Pasa el mouse para preparar, Click para descargar"
        >
            {isReady ? (
                /* Una vez "despierto", renderizamos el Generador de PDF */
                <PDFDownloadLink
                    document={<PresupuestoPDF_V2 presupuesto={presupuesto} type={type} />}
                    fileName={getFileName()}
                    style={{ textDecoration: 'none' }}
                >
                    {({ loading, error }) => {
                        // 1. Si hay error al generar
                        if (error) {
                            console.error("Error PDF:", error);
                            return <span className="text-red-500 text-xs">Error!</span>;
                        }
                        // 2. Si está "pensando" (generando el PDF)
                        if (loading) {
                            return (
                                <span className="flex items-center gap-1 px-2 py-1 bg-gray-100 text-gray-500 rounded border border-gray-200 text-xs font-bold">
                                    <FaSpinner className="animate-spin" /> ...
                                </span>
                            );
                        }
                        // 3. ¡LISTO! Muestra el botón normal (que ahora es un enlace de descarga real)
                        return icon;
                    }}
                </PDFDownloadLink>
            ) : (
                /* Estado "Dormido": Muestra el botón visualmente idéntico, esperando el mouse */
                <span className="cursor-pointer">
                    {icon}
                </span>
            )}
        </div>
    );
};

export default PresupuestoPDFLink;